/* eslint-disable eqeqeq */
import DataStore from "./../stores/DataStore";
import { reaction } from "mobx";
/**
 * Handler, welche eine Bedingung auf einem speziellen Attribut checkt.
 */
class AttributeCondition {
  /**
   * @param {object} params.attrCondition
   * @param {string} params.attrCondition.attribute
   * @param {string} [params.attrCondition.compareAttribute]
   * @param {boolean} [params.attrCondition.lessThan]
   * @param {boolean} [params.attrCondition.biggerThan]
   * @param {function} [params.attrCondition.customCompareFunction]
   * @param {int} [params.attrCondition.max]
   * @param {int} [params.attrCondition.min]
   * @param {*} [params.attrCondition.equals]
   * @param {boolean} [params.attrCondition.filled]
   * @param {string} [params.attrCondition.stringContains]
   * @param {function} [params.attrCondition.customFunction]
   * @param {string[]} [params.attrCondition.multiAttributes] für Bedingungen die auf mehreren Attributen ausgewertet werden sollen
   * @param {function} [params.attrCondition.customMultiAttributeFunction] Funktion auf mehreren Attributen (muss entweder direkt zu bool auswerten oder einen wert zurückgeben der mit customMultiAttributeFunction abgeglichen wird)
   * @param {*} [params.attrCondition.customMultiAttributeFunctionValue]
   */
  constructor(params, root) {
    const {
      // attrCondition: {
      attribute = "",
      compareAttribute = "",
      multiAttributes = [],
      lessThan = undefined,
      biggerThan = undefined,
      customCompareFunction = undefined,
      max = undefined,
      min = undefined,
      equals = undefined,
      filled = undefined,
      stringContains = undefined, // evtl umbenennen?
      customFunction = undefined,
      requestLoadingState,
      // },
      compareattribute = undefined,
      multiattributes = undefined,
      customMultiAttributeFunction = undefined,
      customMultiAttributeFunctionValue = undefined,
      neutralVal = undefined,
    } = params;
    this.attribute = attribute;
    this.compareAttribute = compareAttribute;
    this.lessThan = lessThan;
    this.biggerThan = biggerThan;
    this.customCompareFunction = customCompareFunction;
    this.max = max;
    this.min = min;
    this.equals = equals;
    this.filled = filled;
    this.stringContains = stringContains;
    this.customFunction = customFunction;
    this.attribute = attribute;
    this.compareattribute = compareattribute;
    this.customMultiAttributeFunction = customMultiAttributeFunction;
    this.customMultiAttributeFunctionValue = customMultiAttributeFunctionValue;
    this.multiattributes = multiattributes;
    this.multiAttributes = multiAttributes;
    this.neutralVal = neutralVal;
    this.requestLoadingState = requestLoadingState;
    this.messageHandler = DataStore.getHandler().messageHandler;
    this.DataStore = DataStore;
    this.root = root;
    if (typeof this.requestLoadingState !== "undefined") {
      const requestKey =
        this.DataStore.attributeValues[this.attribute].targetConfig.requestKey;
      if (requestKey) {
        reaction(
          () => this.DataStore.requestStore.requests[requestKey].state,
          () => {
            this.root?.refresh();
          }
        );
      }
    }
    if (this.attribute)
      reaction(
        () => this.DataStore.attributeValues[this.attribute].value,
        () => {
          this.root?.refresh();
          // this.DataStore.dependencyHandler.refresh();
        }
      );
    if (this.compareAttribute)
      reaction(
        () => this.DataStore.attributeValues[this.compareAttribute].value,
        () => this.root?.refresh() // this.DataStore.dependencyHandler.refresh()
      );
    if (this.multiAttributes)
      this.multiAttributes.forEach((id) =>
        reaction(
          () => this.DataStore.attributeValues[id].value,
          () => this.root?.refresh() //this.DataStore.dependencyHandler.refresh()
        )
      );
  }

  /**
   * @function AttributeCondition.getString
   * @return {String} Stingdarstellung der Bedingung samt momentaner Auswertung (fürs debugging)
   */
  getString() {
    let attrString = "";
    if (this.attribute) {
      let atrVal = this.DataStore.attributeValues[this.attribute].value; //this.attributeModul.getValue();
      if (!atrVal) atrVal = "<EMPTY>";
      const attrID = this.attribute;
      if (this.compareAttribute) {
        let comAtrVal =
          this.DataStore.attributeValues[this.compareAttribute].value;
        if (!comAtrVal) comAtrVal = "<EMPTY>";
        if (this.lessThan) {
          attrString =
            `${attrString}([${attrID}]${atrVal}lessThan` +
            `[${this.compareAttribute}]${comAtrVal})`;
        }
        if (this.biggerThan) {
          attrString =
            `${attrString}([${attrID}]${atrVal}biggerThan` +
            `[${this.compareAttribute}]${comAtrVal})`;
        }
        if (this.customCompareFunction) {
          attrString =
            `${attrString}customCompareFunc([${attrID}]${atrVal}` +
            `[${this.compareAttribute}]${comAtrVal})`;
        }
      }
      if (typeof this.max !== "undefined") {
        attrString = `${attrString}([${attrID}]${atrVal} maximal ${this.max.toString()})`;
      }
      if (typeof this.min !== "undefined") {
        attrString = `${attrString}([${attrID}]${atrVal} minimal ${this.min.toString()})`;
      }
      if (typeof this.equals !== "undefined") {
        attrString = `${attrString}([${attrID}]${atrVal} equals ${this.equals.toString()})`;
      }
      if (typeof this.filled !== "undefined") {
        attrString = `${attrString}filled([${this.attribute}]${atrVal})`;
      }
      if (typeof this.stringContains !== "undefined") {
        attrString = `${attrString}([${attrID}]${atrVal} contains ${this.stringContains.toString()})`;
      }
      if (typeof this.customFunction !== "undefined") {
        attrString = `${attrString}customFunction([${attrID}]${atrVal})`;
      }
    }
    // else {
    //   attrString = `${attrString}attributeIDUndefined`;
    // }
    if (this.multiAttributes && this.multiAttributes.length > 0) {
      this.multiattributes = this.multiAttributes.map(
        (id) => DataStore.attributeValues[id].modul
      );
      if (
        this.multiattributes &&
        this.multiattributes.length > 0 &&
        this.multiattributes.every((o) => typeof o === "object")
      ) {
        const values = this.multiattributes.map(
          (modul) =>
            `[${modul.getKey()}]${
              modul.getValueString() ? modul.getValueString() : "<EMPTY>"
            }`
        );
        if (this.customMultiAttributeFunction) {
          attrString = `${attrString}customMultiAttributeFunction(${values})`;
        }
      } else {
        const values = this.multiAttributes.map(
          (id) =>
            `[${id}]${
              typeof DataStore.attributeValues[id].value !== typeof undefined
                ? typeof DataStore.attributeValues[id].value.toString()
                : "<EMPTY>"
            }`
        );
        if (this.customMultiAttributeFunction) {
          attrString = `${attrString}customMultiAttributeFunction(${values})`;
        }
      }
    }
    return attrString;
  }

  /**
   * @function AttributeCondition.evaluate
   * @return {boolean} Auwertung der anfänglich übergebenen Bedingung.
   */
  evaluate() {
    let evalResult = true;
    let atrVal;

    if (this.attribute) {
      atrVal = this.DataStore.attributeValues[this.attribute].value;
    }
    if (this.externAttribute && !this.attribute && this.DataStore.externStore) {
      atrVal = this.DataStore.externStore[this.externAttribute];
    }
    if (typeof this.filled !== "undefined") {
      evalResult = evalResult && atrVal !== undefined && atrVal !== "";
    }
    if (typeof this.requestLoadingState !== "undefined") {
      const requestKey =
        this.DataStore.attributeValues[this.attribute].targetConfig.requestKey;
      if (requestKey) {
        const request = this.DataStore.requestStore.requests[requestKey];
        evalResult = evalResult && request.state === this.requestLoadingState;
      }
    }
    if (typeof this.customFunction !== "undefined") {
      evalResult =
        evalResult &&
        this.customFunction(
          atrVal,
          this.DataStore.attributeValues[this.attribute],
          this.attribute
        );
    }
    if (typeof atrVal !== "undefined" && !(null === atrVal)) {
      let comAtrVal;
      if (this.compareAttribute) {
        comAtrVal = this.DataStore.attributeValues[this.compareAttribute].value;
      }
      if (
        this.externCompareAttribute &&
        !this.compareAttribute &&
        this.DataStore.externStore
      ) {
        comAtrVal = this.DataStore.externStore[this.externAttribute];
      }
      if (this.lessThan) {
        evalResult =
          evalResult && (!atrVal || !comAtrVal || atrVal < comAtrVal);
      }
      if (this.biggerThan) {
        evalResult =
          evalResult && (!atrVal || !comAtrVal || atrVal > comAtrVal);
      }
      if (this.customCompareFunction) {
        evalResult =
          evalResult &&
          (!atrVal ||
            !comAtrVal ||
            this.customCompareFunction(atrVal, comAtrVal));
      }
      if (typeof this.max !== "undefined") {
        evalResult = evalResult && atrVal <= this.max;
      }
      if (typeof this.min !== "undefined") {
        evalResult = evalResult && atrVal >= this.min;
      }
      if (typeof this.equals !== "undefined") {
        evalResult = evalResult && atrVal == this.equals;
      }
      if (typeof this.stringContains !== "undefined") {
        evalResult = evalResult && atrVal.includes(this.stringContains);
      }
    } else if (typeof this.neutralVal !== typeof undefined) {
      return this.neutralVal;
    }

    if (this.multiAttributes && this.multiAttributes.length > 0) {
      const values = this.multiAttributes.map((id) => {
        if (
          typeof this.DataStore.attributeValues[id].value == typeof undefined &&
          typeof this.neutralVal !== typeof undefined
        ) {
          return this.neutralVal;
        }
        return this.DataStore.attributeValues[id].value;
      });
      let externValues = [];
      if (this.multiExternAttributes && this.DataStore.externStore) {
        externValues = this.multiExternAttributes.map((id) => {
          if (
            typeof this.DataStore.externStore[id] == typeof undefined &&
            typeof this.neutralVal !== typeof undefined
          ) {
            return this.neutralVal;
          }
          return this.DataStore.externStore[id];
        });
      }
      if (this.customMultiAttributeFunction) {
        if (this.customMultiAttributeFunctionValue) {
          evalResult =
            this.customMultiAttributeFunction(values, externValues) ==
            this.customMultiAttributeFunctionValue; // wird eeiiigentlich nicht benötigt, weil in die Funktion einkodierbar
        } else {
          evalResult = this.customMultiAttributeFunction(values, externValues);
        }
      }
    }
    return evalResult;
  }
}

export default AttributeCondition;
